// extracted by mini-css-extract-plugin
export default {"WarningIcon":"SwitchIcon__WarningIcon___DjYjS"};